module.exports = "https://static.wanderu.com/static/media/LocationIcon.596437cc.svg";